/**
 * Created by pyt on 2017-03-07.
 */
import { Filter } from '@/common/models';

import LogicalOperator from './FilterLogicalOperator.enum';

export default class FilterGroup {
  type: string;
  filters: Array<Filter | FilterGroup> = [];
  logicalOperator: LogicalOperator;

  constructor(filters = [], logicalOperator = LogicalOperator.OR) {
    this.type = 'FilterGroup';
    this.filters = filters;
    this.logicalOperator = logicalOperator;
  }

  get isEmpty() {
    return this.filters.length === 0;
  }

  toQueryParam() {
    let queryString = '';
    this.filters.forEach((filter) => {
      if (queryString !== '') {
        queryString += ` ${this.logicalOperator} `;
      }
      if (this.logicalOperator === LogicalOperator.NOT) {
        queryString += `${LogicalOperator.NOT} `;
      }
      queryString += filter.toQueryParam();
    });
    return `(${queryString})`;
  }
}
